import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function About() {
  const [c, setC] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/site-content/about");
        setC(data);
      } catch {
        setC({ eyebrow: "", headline: "", intro: "", body: "", stats: [], gallery: [] });
      }
    })();
  }, []);

  if (!c) return <div className="p-12 text-[var(--ff-text-dim)]">Loading...</div>;

  const paragraphs = (c.body || "").split(/\n\s*\n/).filter(Boolean);

  return (
    <div data-testid="about-page" className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24">
      <div className="label-eyebrow mb-6 text-[var(--ff-red)]" data-testid="about-eyebrow">{c.eyebrow}</div>
      <h1 className="font-display text-5xl lg:text-8xl mb-16 max-w-5xl" data-testid="about-headline">{c.headline}</h1>

      <div className="grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-7 space-y-8 text-[var(--ff-text-dim)] text-base lg:text-lg leading-relaxed">
          {c.intro && <p className="text-white" data-testid="about-intro">{c.intro}</p>}
          {paragraphs.map((p, i) => <p key={i} data-testid={`about-paragraph-${i}`}>{p}</p>)}
        </div>
        <div className="lg:col-span-5 space-y-px bg-[var(--ff-border)]">
          {c.stats?.map((s, i) => (
            <div key={i} className="bg-[var(--ff-bg)] p-6 flex justify-between items-center" data-testid={`about-stat-${i}`}>
              <div className="label-eyebrow">{s.label}</div>
              <div className="font-display text-2xl">{s.value}</div>
            </div>
          ))}
        </div>
      </div>

      {c.gallery?.length > 0 && (
        <div className="mt-24 grid md:grid-cols-3 gap-8">
          {c.gallery.map((g, i) => (
            <div key={i} className="aspect-[4/5] relative overflow-hidden surface-card" data-testid={`about-gallery-${i}`}>
              {g.image_url ? (
                <img src={g.image_url} alt={g.title} className="absolute inset-0 w-full h-full object-cover" />
              ) : (
                <div className="absolute inset-0 bg-[var(--ff-surface-hover)] flex items-center justify-center text-[var(--ff-text-dim)] font-mono-ui text-xs">NO IMAGE</div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute bottom-6 left-6 font-display text-3xl">{g.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
